import { BaseService } from "./BaseService";
import type {
  AnalyticsRevenueExportQuery,
  AnalyticsRevenueRangeQuery,
  AvgCheckResponse,
  RevenueByServiceExportQuery,
  RevenueByServiceQuery,
  RevenueByServiceResponse,
  RevenueDistributionExportQuery,
  RevenueDistributionQuery,
  RevenueDistributionResponse,
  TotalRevenueResponse,
} from "@/types/analytics-revenue";

class AnalyticsRevenueService extends BaseService {
  private readonly basePath = "/analytics/revenue";

  getTotal(query: AnalyticsRevenueRangeQuery): Promise<TotalRevenueResponse> {
    return this.get<TotalRevenueResponse>(`${this.basePath}/total`, query);
  }

  getAvgCheck(query: AnalyticsRevenueRangeQuery): Promise<AvgCheckResponse> {
    return this.get<AvgCheckResponse>(`${this.basePath}/avg-check`, query);
  }

  getByService(
    query: RevenueByServiceQuery,
  ): Promise<RevenueByServiceResponse> {
    return this.get<RevenueByServiceResponse>(
      `${this.basePath}/by-service`,
      query,
    );
  }

  getDistribution(
    query: RevenueDistributionQuery,
  ): Promise<RevenueDistributionResponse> {
    return this.get<RevenueDistributionResponse>(
      `${this.basePath}/distribution`,
      query,
    );
  }

  exportTotal(query: AnalyticsRevenueExportQuery): Promise<Blob> {
    return this.getBlob(`${this.basePath}/total/export`, query);
  }

  exportAvgCheck(query: AnalyticsRevenueExportQuery): Promise<Blob> {
    return this.getBlob(`${this.basePath}/avg-check/export`, query);
  }

  exportByService(query: RevenueByServiceExportQuery): Promise<Blob> {
    return this.getBlob(`${this.basePath}/by-service/export`, query);
  }

  exportDistribution(query: RevenueDistributionExportQuery): Promise<Blob> {
    return this.getBlob(`${this.basePath}/distribution/export`, query);
  }
}

export const analyticsRevenueService = new AnalyticsRevenueService();
